const multiSelectStyle = {
  '.selectionBox': {
    minHeight: '300px',
  },
  '.centerButtonBox': {
    minHeight: '300px',
  },
};

export default multiSelectStyle;
